import { CampaignCategory, CampaignCostHandlingMethod, ReviewTarget } from '~/generated/graphql'

export const CAMPAIGN_FORM_TITLE = {
  campaignName: 'キャンペーン名',
  image: '商材のイメージ写真',
  offerTerm: '募集期間',
  postTerm: '投稿期間',
  advAccountStatus: '会社名の公開設定',
  gross: '投稿報酬単価（税抜）',
  selectionMaxLimit: '採用可能人数',
  attention: 'PRに関する注意事項',
  selectServiceGenre: '商材のジャンル',
  offerAutoMessage: '採用時にインフルエンサーに送る自動メッセージ',
  gender: '希望するインフルエンサーの性別',
  age: '希望するインフルエンサーの年齢層',
  ageLimit: '応募の年齢制限',
  desiredFollowers: '募集の要望',
  name: '商材の名称',
  summaryStore: '商材の紹介文',
  summaryProduct: '商材の紹介文',
  sponsorServiceStore: 'インフルエンサーに無償提供するサービス',
  sponsorServiceProduct: 'インフルエンサーに無償提供する商品',
  sponsorServicePriceStore: '商材の定価',
  sponsorServicePriceProduct: '商材の定価',
  sponsorServicePriceExpense: '立替金額の上限',
  target: '提供対象の制限',
  followerMinLimit: 'フォロワー数が何人以上のインフルエンサーに宣伝してほしいですか？',
  urlStore: '商材の内容が確認できるURL',
  urlProduct: '商材の内容が確認できるURL',
  urlExpense: 'インフルエンサーが購入する商材のURL',
  requestUrl: 'インフルエンサーの投稿に載せたいSNSアカウント名',
  requestYoutubeUrl: '概要欄に記載してほしいURL',
  wantInfluencer: 'インフルエンサーにやってほしいこと(有料)',
  snsType: 'PRを募集するSNS',
  snsPostRedirectUrl: '投稿の遷移先URL',
  question: 'インフルエンサーへの事前質問',
  hashTagSetup: 'インフルエンサーの投稿に載せるハッシュタグ',
  companion: '同伴者へのサービス無償提供について',
  shopAddress: '店舗情報',
  other: 'その他',
  guidance: '商材に関するご案内',
  sponsorService: 'インフルエンサーに無償提供する商品の概要',
  applicationConditions: '応募条件',
  prTarget: '商材のターゲット',
  maxCompanionCount: '同サービスを無償提供する同伴者の最大数',
  maxCompanionCountExpense: '同サービスを精算対象とする同伴者の最大数',
  snsPostTypeRestrictions: '投稿形式の制限',
  desiredLanguages: '投稿を希望する言語',
} as const

export const REVIEW_TARGET_LABEL: Record<ReviewTarget, string> = {
  // キャンペーン 基本情報
  [ReviewTarget.CampaignName]: 'インフルエンサーに無償提供するサービス',
  [ReviewTarget.CoverImages]: 'キャンペーン画像',
  [ReviewTarget.Summary]: 'キャンペーンの概要',
  [ReviewTarget.OfferAutoMessage]: '採用時に送られる自動応答メッセージ',

  // キャンペーン インフルエンサーの投稿に関する情報
  [ReviewTarget.Attention]: 'PRに関する注意事項',
  [ReviewTarget.TagList]: '希望ハッシュタグ',
  [ReviewTarget.RequestUrl]: 'SNSアカウント名',

  // キャンペーン 提供サービスに関する情報
  [ReviewTarget.SponsorService]: '提供サービス（商品）',
  [ReviewTarget.SponsorServicePrice]: '提供サービス（商品）の本来の価格',

  // キャンペーン 募集するインフルエンサーに関する情報
  [ReviewTarget.Gender]: '募集するインフルエンサーの性別',
  [ReviewTarget.AgeLimit]: '募集するインフルエンサーの年齢制限',

  // 投稿報酬型キャンペーンで必要な情報
  [ReviewTarget.Gross]: '投稿報酬単価（税抜）',
  [ReviewTarget.WantInfluencer]: 'インフルエンサーにやって欲しいこと',

  // 店舗キャンペーンで必要な情報
  [ReviewTarget.ShopAddress]: '店舗住所・最寄駅',
  [ReviewTarget.Companion]: '同伴者',
  [ReviewTarget.Reservations]: '日程調整の方法',

  [ReviewTarget.Url]: '参考URL',
  [ReviewTarget.ReservableSchedules]: '来店可能日時',
  [ReviewTarget.Other]: 'その他',

  [ReviewTarget.LegalAttention]: 'PRに関する注意事項',
  [ReviewTarget.LegalTagList]: '希望ハッシュタグ',
  [ReviewTarget.LegalRequestUrl]: 'SNSアカウント名',
  [ReviewTarget.LegalSponsorService]: '提供サービス（商品）',
  [ReviewTarget.LegalCampaignName]: 'インフルエンサーに無償提供するサービス',
  [ReviewTarget.LegalCoverImages]: 'キャンペーン画像',
  [ReviewTarget.LegalSummary]: 'キャンペーンの概要',
  [ReviewTarget.LegalOfferAutoMessage]: '採用時に送られる自動応答メッセージ',
  [ReviewTarget.LegalWantInfluencer]: 'インフルエンサーにやって欲しいこと',
  [ReviewTarget.LegalOthers]: 'その他',
  [ReviewTarget.LegalGuidance]: 'ご案内',
  [ReviewTarget.LegalSnsPostRedirectUrl]: '投稿の遷移先URL',
  [ReviewTarget.LegalSpecifiedPrText]: 'インフルエンサーの投稿に含める文章【文言指定オプション】',

  // V4
  [ReviewTarget.Guidance]: 'ご案内',
  [ReviewTarget.SnsPostRedirectUrl]: '投稿の遷移先URL',
  [ReviewTarget.SpecifiedPrText]: 'インフルエンサーの投稿に含める文章【文言指定オプション】',
  [ReviewTarget.SearchGenre]: 'PR対象サービスのジャンル',
  [ReviewTarget.SearchSubGenre]: '商材のサブジャンル',
  [ReviewTarget.MaxCompanionCount]: '最大同伴者人数',
  [ReviewTarget.SnsPostType]: '希望する投稿形式',
} as const

// 入力項目のバリデーションエラーメッセージ
export const CAMPAIGN_ERROR_MESSAGE = {
  REQUIRED: '必須項目です',
  MAX_LENGTH: '文字数が上限に達しました',
  SPONSOR_SERVICE_MAX_LENGTH: '70文字以内で入力してください',
  POSTAL_CODE_LENGTH: '郵便番号は半角数字7桁の形式です',
  TEL_LENGTH: '電話番号は半角数字10桁または11桁です',
  TEL_FORMAT: '電話番号の形式が正しくありません',
  URL_FORMAT: 'URLの形式が正しくありません。URLの先頭が https:// または http://になっているか確認してください。',
  EMAIL_FORMAT: 'メールアドレスの形式が正しくありません',
  [ReviewTarget.Other]: 'その他',

  [ReviewTarget.LegalAttention]: 'PRに関する注意事項',
  [ReviewTarget.LegalTagList]: '希望ハッシュタグ',
  [ReviewTarget.LegalRequestUrl]: 'SNSアカウント名',
  [ReviewTarget.LegalSponsorService]: '提供サービス（商品）',
  [ReviewTarget.LegalCampaignName]: 'インフルエンサーに無償提供するサービス',
  [ReviewTarget.LegalCoverImages]: 'キャンペーン画像',
  [ReviewTarget.LegalSummary]: 'キャンペーンの概要',
  [ReviewTarget.LegalOfferAutoMessage]: '採用時に送られる自動応答メッセージ',
  [ReviewTarget.LegalWantInfluencer]: 'インフルエンサーにやって欲しいこと',
  [ReviewTarget.LegalOthers]: 'その他',
} as const

export const GUIDANCE_HELPER_TEXT = {
  [CampaignCategory.Product]: '商品はクール便で発送しますのでお受け取りにご注意ください。',
  [CampaignCategory.Service]: '当日は動きやすい服装でお越しください。',
  [CampaignCostHandlingMethod.ExpenseCampaign]:
    '一般の方と同様にご来店ください。\n' + '※繁忙期等予約が必要な場合がありますのでご確認お願いいたします。',
  [CampaignCostHandlingMethod.NoChargeCampaign]: 'キャンペーンに記載されている「購入リンク」からご購入下さい。',
}

export const PARTIAL_CP_CONFIRMATION_TITLE = 'キャンペーン情報'
export const CONFIRMATION_WARNING_MESSAGE =
  '※申請された内容が審査承認された場合は、そのままインフルエンサーに公開されますので、必ずご確認ください。'
